import React, { Component } from 'react';
import axios from 'axios';
import appConfig from '../../../../config';
import Modal from '../../../commons/Modal/Modal';
import FloatingActionButton from '../../../commons/Buttons/FloatingActionButton';
import {InputField, DateField,
    TextAreaField } from '../../../commons/Inputs';

let moment = window.moment;
let $ = window.jQuery;

export default class TreatmentPlan extends Component {

	state = {
		headers : [
            {key : 'date', label : 'Date'},
            {key : 'procedures', label : 'Treatment'},
            {key : 'notes', label : 'Notes'},
            {key : 'cost', label : 'Cost'},
            {key : 'discount', label : 'Discount'},
            {key : 'total', label : 'Total'},
            {key : 'id', label : 'Id'} // for table sorting
        ],
        dataTable : [],
        buttonState : 'Save',
        isSaving : false,
        treatmentPlanDate : moment().format('MMMM DD, YYYY'),
        procedureItems : [],
        noteTextArea : '',
        amountChargeInput : 0,
        discountInput : 0,
        totalCost : 0,
        totalDiscount : 0,
        allTotal : 0,
        dataGroupItem : []
	}

    handleTreatmentPlanPreview = (e) => {
        let session = localStorage.getItem('token');

        // eslint-disable-next-line
        let treatmentPlanDataTable = $('#treatmentPlanDataTable').DataTable();
        let tr = $(e.target).closest('tr');
        let row = treatmentPlanDataTable.row( tr );
        let datas = row.data();

        let url = appConfig.apiUrl + 'dental/treatmentPlan/' + this.props.storeParams.patientId + '/pdf/' + datas.sort + '?access_token=' + session;
        // console.log(datas,url);
        $('#treatmentPlanPDF').find('iframe').prop('src', url);
        $('#treatmentPlanPDF').modal('show');
    }

    handleCloseTreatmentPlanPDFPreview = (e) => {

    }

	getTreatmentPlanData = () => {

        let url = appConfig.apiUrl + 'dental/treatmentPlan/' + this.props.storeParams.patientId;
        
        axios.get(url).then((response) => {
            // console.log(response.data.data);
            let data = [];
            for (let item of Object.keys(response.data.data)) {
                let tmp = {
                    name: moment(item*1000).format('MMM DD, YYYY'),
                    action: '<button class="btn btn-xs treatmentPlan-preview blue" data-timestamp='+item+' type="button"><i class="fa fa-print" style="cursor: pointer"></i></button>',
                    data: response.data.data[item],
                    sort: item
                };

                data.push(tmp);
            }

            this.addRowsToTable(data);
            this.setState({
                dataTable : data
            });

        }).catch((error) => {

        });
	}

    addRowsToTable = (data) => {

        // eslint-disable-next-line
        let treatmentPlanDataTable = $('#treatmentPlanDataTable').DataTable();

        treatmentPlanDataTable.clear();
        for (let item of data) {
            treatmentPlanDataTable.row.add(item);
        }

        treatmentPlanDataTable.draw();
    }

    initializeTable = () => {
        // eslint-disable-next-line
        let treatmentPlanDataTable = $('#treatmentPlanDataTable').DataTable( {
            "data": this.state.data,
            "columns": [
                {
                    "className": 'details-control',
                    "orderable": false,
                    "data": null,
                    "defaultContent": ''
                },
                { "data": "name" },
                { "data": "action"},
                
                {
                    "visible" : false,
                    "searchable" : false,
                    "data" : "sort"
                }
            ],
            "order": [[3, 'desc']],
            "destroy": true
        } );

        let self = this;

        $('#treatmentPlanDataTable tbody').on('click', 'td.details-control', function () {

            var tr = $(this).closest('tr');
            var row = treatmentPlanDataTable.row( tr );
            
            if ( row.child.isShown() ) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                treatmentPlanDataTable.rows().eq(0).each( function ( idx ) {
                    let rowEach = treatmentPlanDataTable.row( idx );
             
                    if ( rowEach.child.isShown() ) {
                        rowEach.child.hide();
                    }
                });
                self.setState({
                    dataGroupItem : row.data().data
                },() => {
                    row.child(self.format()).show();
                    tr.addClass('shown');
                });
                
            }

            self.handlePopConfirmation();

        });

        $(document).on('click', '.treatmentPlan-preview', (e) => {
            this.handleTreatmentPlanPreview(e);
        });
    }

    handlePopConfirmation = () => {
        let treatmentPlanDataTable = $('#treatmentPlanDataTable').DataTable();
        let self = this;
        $('.deletePopover').confirmation({
            popout: true,
            btnOkClass: 'btn btn-primary btn-sm',
            btnCancelClass: 'btn btn-danger btn-sm',
            container: 'body',
            placement : 'top',
            onConfirm: function() {
                let treatmentPlanId = $(this).data('id');
                let tr = $(this).parents('table').closest('tbody').find('.shown');
                
                let row = treatmentPlanDataTable.row( tr );

                self.handleDelete(treatmentPlanId,row);
            }
        });
    }

    handleDelete = (id,row) => {
        
        let url = appConfig.apiUrl + 'dental/treatmentPlan/' + id;
        let dataGroupItem = this.state.dataGroupItem;
        // eslint-disable-next-line
        let index = dataGroupItem.findIndex((item) => item.id == id);
        
        axios.delete(url).then((res) => {
            console.log(res);
            $('.deletePopover').confirmation('hide');

            dataGroupItem.splice(index, 1);
            
            this.setState({
                dataGroupItem
            },() => {
                
                row.child(this.format());
                this.handlePopConfirmation();
            });

        }).catch((error) => {

        });

    }

    format  = ( d ) => {
        let data = this.state.dataGroupItem;
        // console.log('row data: ', d); 
        // `d` is the original data object for the row
        let html = '<table cellpadding="5" cellspacing="0" class="table table-bordered tableTreatmentPlanList" border="0" style="padding-left: 50px; width: 100%">'+
                '<thead>'+
                    '<tr>'+
                        '<th>Treatments</th>'+
                        '<th>Tooth</th>'+
                        '<th>Notes</th>'+
                        '<th>Cost</th>'+
                        '<th>Discount</th>'+
                        '<th>Total</th>'+
                    '</tr>'+
                '</thead>'+
                '<tbody>';

        let totalCost = 0;
        let totalDiscount = 0;
        let allTotal = 0;

        data.sort((a, b) => { // sort id by descending
            return b.id - a.id
        });
            
            for (let treatment of data) {
                let total = Number(treatment.cost) - Number(treatment.discount);
                allTotal += total;
                totalCost += Number(treatment.cost);
                totalDiscount += Number(treatment.discount);

                this.setState({
                    totalCost,
                    totalDiscount,
                    allTotal
                }, () => {
                    
                });

                let button =    '<button href="#" class="btn btn-xs tooltips deletePopover red" data-original-title="Delete" data-id="'+treatment.id+'" data-toggle="confirmation" data-singleton="true">'+
                                    '<i class="glyphicon glyphicon-remove" data-id={treatment.id}></i>'+
                                '</button>';

                html += '<tr data-row="'+ treatment.id +'">'+
                            '<td>'+treatment.procedureItem[0].procedure+'</td>'+
                            '<td>'+treatment.tooth_numbers+'</td>'+
                            '<td>'+treatment.notes+'</td>'+
                            '<td>'+parseFloat(treatment.cost).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')+'</td>'+
                            '<td>'+parseFloat(treatment.discount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')+'</td>'+
                            '<td>'+parseFloat(total).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')+'</td>'+
                            '<td>'+button+'</td>'+
                        '</tr>';
            }

            html +=     '<tr>'+
                            '<td colspan="4" class="text-right" style="border-top: 1px solid #000">Estimated Amount : </td>'+
                            '<td class="text-left" style="border-top: 1px solid #000">'+ parseFloat(totalCost).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') +'</td>'+
                        '</tr>'+
                        '<tr>'+
                            '<td colspan="4" class="text-right">Total Discount : </td>'+
                            '<td class="text-left">'+ parseFloat(totalDiscount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') +'</td>'+
                        '</tr>'+
                        '<tr>'+
                            '<td colspan="4" class="text-right">Grand Total : </td>'+
                            '<td class="text-left" style="border-top: 1px solid #000">'+ parseFloat(allTotal).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') +'</td>'+
                        '</tr>'

            html +=  '</tbody>';

            html +=  '</table>';


        return html;
        
    };

	getProcedures = () => {
		let url = `${appConfig.apiUrl}management/dental/procedures`;

		axios.get(url).then((res) => {
            res.data.data.unshift({id : 0,procedure : '',price : 0});
			this.setState({
                procedureItems : res.data.data
            })
		}).catch((error) => {

		});
	}

	componentWillMount() {
		this.getProcedures();
	}

	componentDidMount() {
		$('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

            let target = e.target.href.split('#');
            let index = target.findIndex((item) => {
                return item === 'treatmentPlanPage'
            });
            
            if (index >= 0) {
                this.initializeTable();
                this.getTreatmentPlanData();
            }
        });

        $('.select2-multiple-procedurePlan').select2({
            placeholder: 'Select procedure',
            width: null,
            allowClear: true
        });

        $('.select2-multiple-procedurePlan').on('select2:select', (e) => {
            let proPrice = e.params.data.element.dataset.price;
            let charge = this.state.amountChargeInput;
                charge = 0;
            let amount = Number(proPrice) + charge;
            this.setState({
                amountChargeInput : amount
            })
        })

        $('#costPlan').inputmask("numeric", {
            radixPoint: ".",
            groupSeparator: ",",
            // digits: 2,
            autoGroup: true,
            // prefix: '₱ ',
            min : 0,
            rightAlign: false,
            autoUnmask: true,
            max: 999999.99, //max val on api DECIMAL(8, 2)
            oncomplete : (e) => {
                this.setState({
                    amountChargeInput: e.target.value
                });
            },
            oncleared : (e) => {
                this.setState({
                    amountChargeInput: 0
                });
            }
        });

        $('#discountPlan').inputmask("numeric", {
            radixPoint: ".",
            groupSeparator: ",",
            // digits: 2,
            autoGroup: true,
            // prefix: '₱ ',
            min : 0,
            rightAlign: false,
            autoUnmask: true,
            max: 999999.99, //max val on api DECIMAL(8, 2)
            oncomplete : (e) => {
                this.setState({
                    discountInput: e.target.value
                });
            },
            oncleared : (e) => {
                this.setState({
                    discountInput: 0
                });
            }
        });
	}

	handleCloseModal = () => {

	}

	handleSaveTreatmentPlan = () => {
        this.setState({
            isSaving : true
        });

		let treatmentPlanForm = $('#treatmentPlanForm');
		let datas = treatmentPlanForm.serializeArray();

        datas.map((item, i) => {
            if(item['name'] === 'tooth_numbers')
            {
                item['value'] = $('#toothSelectId').val();
            }
        });

		
        let url = appConfig.apiUrl + 'dental/treatmentPlan/' + this.props.storeParams.patientId;

        axios.post(url,$.param(datas)).then((response) => {
            this.getTreatmentPlanData();
            $('#addTreatmentPlanModal').modal('hide');

            this.setState({
                isSaving : false
            })
        }).catch((error) => {

        })
	}

	handleAddTreatmentPlan = () => {
		$('#addTreatmentPlanModal').modal('show');
	}

	onTagsAdded = () => {

	}

	onTagsRemove = () => {

	}

	render() {
		return (
			<div className="row">
				<div className="col-md-12">
                    <table id="treatmentPlanDataTable" className="table table-striped table-bordered table-hover" cellSpacing="0" width="100%">
                        <thead>
                            <tr>
                                <th/>
                                <th>Treatment Plan</th>
                                <th>Action</th>
                                <th/>
                            </tr>
                        </thead>
                    </table>
				</div>

				<Modal
                    id="addTreatmentPlanModal"
                    header="Add New Plan"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleSaveTreatmentPlan}
                    positiveButton={this.state.buttonState}
                    isSaving={this.state.isSaving}
                    width="640">

                    	<div className="row">
                    		<form id="treatmentPlanForm" onSubmit={(e) => { return false; }}>
                    			<div className="col-md-12">
                    				<div className="row">
                    					<div className="col-md-12">
	                                        <DateField val={this.state.treatmentPlanDate} id="datePlan" label="Date" help="input date" onChange={(e) => {this.setState({treatmentPlanDate : e.target.value})}} />
	                                    </div>
	                                    <div className="col-md-12">
	                                        <div className="form-group form-md-line-input">
                                                <select id="procedureSelect2Input" className="form-control select2-multiple-procedurePlan" name="procedures">
                                                    {this.state.procedureItems.map((item, i) => {
                                                        return <option key={i} value={item.id} data-price={item.price}>{item.procedure}</option>
                                                    })}
                                                </select>
                                                <label htmlFor="procedureSelect2Input">Procedure</label>
                                            </div>
	                                    </div>
                                        <div className="col-md-12">
                                            <div className="form-group form-md-line-input">
                                                <select id="toothSelectId" className="form-control select2-multiple-tooth" name="tooth_numbers" multiple>
                                                    <optgroup label="Adult">
                                                        <option value="11">11</option>
                                                        <option value="12">12</option>
                                                        <option value="13">13</option>
                                                        <option value="14">14</option>
                                                        <option value="15">15</option>
                                                        <option value="16">16</option>
                                                        <option value="17">17</option>
                                                        <option value="18">18</option>
                                                        <option value="21">21</option>
                                                        <option value="22">22</option>
                                                        <option value="23">23</option>
                                                        <option value="24">24</option>
                                                        <option value="25">25</option>
                                                        <option value="26">26</option>
                                                        <option value="27">27</option>
                                                        <option value="28">28</option>
                                                        <option value="31">31</option>
                                                        <option value="32">32</option>
                                                        <option value="33">33</option>
                                                        <option value="34">34</option>
                                                        <option value="35">35</option>
                                                        <option value="36">36</option>
                                                        <option value="37">37</option>
                                                        <option value="38">38</option>
                                                        <option value="41">41</option>
                                                        <option value="42">42</option>
                                                        <option value="43">43</option>
                                                        <option value="44">44</option>
                                                        <option value="45">45</option>
                                                        <option value="46">46</option>
                                                        <option value="47">47</option>
                                                        <option value="48">48</option>
                                                    </optgroup>
                                                    <optgroup label="Child">
                                                        <option value="51">51</option>
                                                        <option value="52">52</option>
                                                        <option value="53">53</option>
                                                        <option value="54">54</option>
                                                        <option value="55">55</option>
                                                        <option value="61">61</option>
                                                        <option value="62">62</option>
                                                        <option value="63">63</option>
                                                        <option value="64">64</option>
                                                        <option value="65">65</option>
                                                        <option value="71">71</option>
                                                        <option value="72">72</option>
                                                        <option value="73">73</option>
                                                        <option value="74">74</option>
                                                        <option value="75">75</option>
                                                        <option value="81">81</option>
                                                        <option value="82">82</option>
                                                        <option value="83">83</option>
                                                        <option value="84">84</option>
                                                        <option value="85">85</option>
                                                    </optgroup>
                                                </select>
                                                <label htmlFor="toothNumbersId">Tooth No.</label>
                                            </div>
                                        </div>
	                                    <div className="col-md-12">
	                                        <TextAreaField val={this.state.noteTextArea} id="notes" label="Notes" help="Notes" onChange={(e) => {this.setState({noteTextArea : e.target.value})}} />
	                                    </div>
	                                    <div className="col-md-12">
	                                        <InputField val={this.state.amountChargeInput} id="cost" label="Cost" help="Cost" type="text" onChange={(e) => {this.setState({amountChargeInput : e.target.value})}} />
	                                    </div>
	                                    <div className="col-md-12">
	                                        <InputField val={this.state.discountInput} id="discountPlan" label="Discount" help="Discount" type="text" onChange={(e) => {this.setState({discountInput : e.target.value})}} />
	                                    </div>
                    				</div>
                    			</div>
                    		</form>
                    	</div>

                </Modal>

                <div id="treatmentPlanPDF" data-width="900" className="modal fade in"
                     tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">

                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.handleCloseTreatmentPlanPDFPreview}
                                    data-dismiss="modal" aria-hidden="true" />
                            <h4 className="modal-title">Treatment Plan</h4>
                        </div>
                        <div className="modal-body">
                            <iframe style={{ width: '100%', height: '500px'}}></iframe>
                        </div>
                    </div>
                </div>

                <FloatingActionButton 
                    title="Add new treatment" 
                    onClick={this.handleAddTreatmentPlan} />
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Treatment_plan/TreatmentPlan.js
 **/